// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Breadcrumbs from "../../layouts/dashboardpages/Breadcrumbs";
import Tooltip from '@mui/material/Tooltip';
//import Footer from "layouts/Footer";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop } from "@mui/material";
import "rsuite/dist/rsuite.min.css";
import { Box } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';
import DoneIcon from '@mui/icons-material/Done';
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE, COLLECTION } from "constants.js";

function ManageCategories(props) {

  const navigate = useNavigate();
  const type = props.props.type;
  const { pid } = useParams();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [collectionData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");

  const updateStatus = async (id, newStatus = 1) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/collection/updateStatus/" + id + '/' + newStatus + "/" + type,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(prevData => {
            const newData = { ...prevData };
            const rows = newData.data.rows.map(row => {
              if (row.id === id) {
                return { ...row, status: newStatus };
              }
              return row;
            });
            newData.data.rows = rows;
            return newData;
          });
          toast.success(t(response.data.message));
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }
  const changeStatus = async (id) => {
    setIsLoading(true);

    axios({
      // Endpoint to send files
      url: BASE + "api/collection/remove/" + id + '/' + type,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const updatedRows = collectionData.data.rows.filter((row) => row.id !== id);
          setData({
            ...data,
            data: {
              ...data.data,
              rows: updatedRows
            }
          });
          toast.success(t(response.data.message));
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/collection/list",
      method: "POST",
      data: { "parentId": (pid == undefined) ? 0 : parseInt(pid), "type": type },
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, [pid, type]);

  const columns = [
    { Header: t("id"), accessor: "id", align: "left" },
    { Header: t("name"), accessor: "name", align: "left" },
    { Header: t("childCount"), accessor: "childCount", align: "left" },
    { Header: t("handle"), accessor: "handle", align: "left" },
    { Header: t("collectionId"), accessor: "collectionId", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const finalObj = [];
  const finalNav = [];
  var currentPageBreadcrumb = '';

  for (let key in collectionData.data) {
    if (key == 'rows') {
      collectionData.data[key].map(function (val, index) {
        let serviceType = (type == COLLECTION.PRODUCT) ? 'productCollection' : 'serviceCollection';
        let tempObj = {
          id: "#" + val.id, name: (val.childCount > 0) ? (<Link to={'/' + serviceType + '/list/' + val.id}>{val.name}</Link>) : (val.name),
          childCount: val.childCount, handle: val.handle, collectionId: val.collectionId, status: (val.status == 1) ? t('active') : t('inactive'),
          action:
            <span className="actionLinksStyle">
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("collection", "read") || checkPrivilege("collection", "write")))) ?
                <MDTypography component="a" href={'#'} onClick={(event) => { event.preventDefault(); navigate("/" + serviceType + "/edit/" + val.id + '/' + type) }} variant="caption" color="text" fontWeight="medium">
                  <Tooltip title={t('edit')}><Box className="ActionEdit paddingRight5"><EditIcon /></Box></Tooltip>
                </MDTypography>
                :
                null
              }
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("collection", "delete")))) ?
                <MDTypography component="a" onClick={() => changeStatus(val.id)}> <Tooltip title={t('delete')}><Box className="ActionDelete paddingRight5"><DeleteIcon /></Box></Tooltip></MDTypography>
                :
                null
              }
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("collection", "write")))) ?
                <MDTypography component="a" onClick={() => updateStatus(val.id, (val.status == 1) ? 0 : 1)}>
                  <span className="generalFont">
                    {(val.status == 0) ? <Tooltip title={t('activate')}><Box className="ActionActive"><DoneIcon /></Box></Tooltip> : (val.status == 1) ? <Tooltip title={t('inactivate')}><Box className="ActionBlock"><BlockIcon /></Box></Tooltip> : 'x' + val.status}
                  </span>
                </MDTypography>
                :
                null
              }
            </span>
        };
        finalObj.push(tempObj);
      })
    } else if (key == "parents") {
      finalNav.push(collectionData.data[key]);
      currentPageBreadcrumb = collectionData.data[key][0].name;
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(type == COLLECTION.PRODUCT) ? t('productCollections') : (type == COLLECTION.SERVICE) ? t('serviceCollection') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} ><CircularProgress color="inherit" /></Backdrop>

      {(Object.keys(collectionData).length > 0) ?
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox mx={2} mt={0} py={3} px={2} variant="gradient">
              {(rows.length > 0 && pid > 0) ?
                <Grid item xs={12} sm={12} md={12} >
                  <Breadcrumbs icon="All" title={currentPageBreadcrumb} route={finalNav} light={false} type={type} />
                </Grid>
                : null
              }
            </MDBox>
            <MDBox pt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted={false}
                entriesPerPage={{ defaultValue: 100 }}
                showTotalEntries={false}
                noEndBorder
              />
            </MDBox>
          </Card>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageCategories;
